const dateCalculation = (days) => {

    const millisecondsOfTheDay = 86400000;
        const daysOfTheWeek = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']
        const now = new Date();
        const milliseconds = now.getTime() + days * millisecondsOfTheDay;
        const newDate = new Date(milliseconds);
        const currentYear = newDate.getFullYear();
        const currentMonth = newDate.getMonth() + 1;
        const currentDay = newDate.getDate();
        const dateFormat = currentMonth < 10 ? (currentDay < 10 ? `${currentYear}-0${currentMonth}-0${currentDay}` : `${currentYear}-0${currentMonth}-${currentDay}`) : (currentDay < 10 ? `${currentYear}-${currentMonth}-0${currentDay}` : `${currentYear}-${currentMonth}-${currentDay}`);
        const dayOfTheWeek = `${currentDay}, ${daysOfTheWeek[newDate.getDay()]}`;
        return [dateFormat, dayOfTheWeek];
};

export default dateCalculation;
